import React, { useContext, useRef, useState } from "react";

import styles from "./styles/BeneficiaryLogin.module.css";
import { useEffect } from "react";
import { pbdkf2 } from "../../Utils/OstreonEncryption";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import SHA from "sha.js";
import CCCalendar from "../User/CC Calendar/CCCalendar";
import { isValidDateFormat } from "../../Utils/isValidDateFormat";
import { submitCaptcha } from "../../Utils/captcha";
import Info from "../User/Info/info";
import { serverLogout } from "../../Utils/serverLogout";
import { isValidEmail } from "../../Utils/isValidEmail";
import { BeneficiarySorry } from "../Beneficiary/BeneficiarySorry";
import { LanguageContext } from "../../Context/changeLanguageProvider";

const base_url = config.base_url;
function BeneficiaryLogin() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    serverLogout();
  }, []);
  const navigate = useNavigate();
  const inputRefs = useRef([]);
  const [error, setError] = useState({
    email: "",
    birthday: "",
    key: "",
    error: "",
  });

  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.BeneficiaryLogin
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.BeneficiaryLogin);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const [denied, setDenied] = useState(false);
  const [loginDisabled, setLoginDisabled] = useState(false);
  const resetError = () => {
    Object.keys(error).forEach((key) => {
      setError((prevError) => ({ ...prevError, [key]: null }));
    });
  };
  const [processing, setProcessing] = useState();
  const [recovery_key, setKey] = useState({
    seed1: "",
    seed2: "",
    seed3: "",
    seed4: "",
    seed5: "",
    seed6: "",
    seed7: "",
    seed8: "",
  });
  const [data, setData] = useState({
    email: "",
    birthday: "",
  });
  const validateData = async () => {
    resetError();
    const newErrors = {};

    if (data.email === "") {
      newErrors.email = dublicatedcontent.dublicatedText79;
    }

    if (checkEmptyRecoveryKey(recovery_key)) {
      newErrors.key = content.BeneficiaryLoginRecoveryCodeError1;
    }

    if (data.email && !isValidEmail(data.email)) {
      newErrors.email = dublicatedcontent.dublicatedText47;
    }

    if (data.birthday && !isValidDateFormat(data.birthday)) {
      newErrors.birthday = dublicatedcontent.dublicatedText48;
    }

    if (
      Object.keys(newErrors).length > 0 ||
      checkEmptyRecoveryKey(recovery_key)
    ) {
      setError(newErrors);
      setTimeout(() => {
        Object.keys(error).forEach((key) => {
          setError((prevError) => ({ ...prevError, [key]: null }));
        });
      }, 5000);
    } else {
      var joined_key = "";

      Object.keys(recovery_key).map((seed) =>
        joined_key
          ? (joined_key = joined_key + "-" + recovery_key[seed])
          : (joined_key = recovery_key[seed])
      );
      const [pbdkf2hash] = await pbdkf2(
        `${data.email.toLowerCase()}:${
          data.birthday
        }:${joined_key.toLowerCase()}`,
        "OSTREON",
        100000,
        32 * 8
      );
      console.log(joined_key);
      let token;
      try {
        setLoginDisabled(true);
        token = await submitCaptcha();
      } catch (e) {
        console.log(e);
        setLoginDisabled(false);
        return setError({ ...error, error: dublicatedcontent?.dublicatedText49 });
      }
      setProcessing(dublicatedcontent?.dublicatedText50);
      fetch(base_url + "beneficiary/login", {
        method: "POST",
        mode: "cors",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-type": "application/x-www-form-urlencoded",
          credentials: "include",
        },
        body: `username=${data.email}&pbdkf2hash=${pbdkf2hash}&token=${token}`,
        credentials: "include",
      })
        .then((res) => {
          return res;
        })
        .then(async (res) => {
          if (res.status === 403)
            return setError({
              ...error,
              error: content?.BeneficiaryLoginCredentialsError,
            });
          if (res.status === 429)
            return setError({
              ...error,
              error:
                dublicatedcontent?.dublicatedText51,
            });
          if (res.status === 404) {
            const text = await res.text();
            if (text === "inactive") return setDenied(true);
            else
              return setError({
                ...error,
                error:
                  content?.BeneficiaryLoginActivateError,
              });
          }
          if (res.status === 498)
            return setError({ ...error, error: dublicatedcontent?.dublicatedText49 });
          if (res.status !== 200)
            return setError({
              ...error,
              error: content?.BeneficiaryLoginGeneralError,
            });
          const beneficiary_key = SHA("sha256")
            .update(
              `${data.email.toLowerCase()}:${
                data.birthday
              }:${joined_key.toLowerCase()}`
            )
            .digest("hex");
          window.sessionStorage.setItem(
            "ostreon_beneficiary_key",
            beneficiary_key
          );
          navigate("./OTP", { replace: true, state: { username: data.email } });
          return;
        })
        .catch((e) => {
          setError({ ...error, error: dublicatedcontent?.dublicatedText78 });
          console.log(error);
        })
        .finally((_) => {
          setProcessing();
          setLoginDisabled(false);
          setTimeout(() => {
            resetError();
          }, 5000);
        });
    }
  };

  const checkEmptyRecoveryKey = (obj) => {
    for (let key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === "") {
        return true;
      }
    }
    return false;
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js?render=6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu";
    document.body.appendChild(script);
  }, []);

  const changeData = (value, field) => {
    setData((prevData) => ({ ...prevData, [field]: value }));
  };
  // const changeKey = (seed, value) =>{
  //     console.log(value)
  //     const regex = /^([A-Za-z0-9]{4}-){7}[A-Za-z0-9]{4}$/;
  //     if (regex.test(value)) {
  //         const parts = value.split("-")
  //         let joined_key={"seed1":"","seed2":"","seed3":"","seed4":"","seed5":"","seed6":"","seed7":"","seed8":""}
  //         parts.map((e, index)=>{
  //             joined_key[`seed${index+1}`]=e
  //             return null
  //         })
  //         setKey(joined_key)
  //       } else {
  //         setKey(Object.assign(recovery_key, {[seed]:value}))
  //       }
  // }
  const changeKey = (seed, value_, index) => {
    console.log(value_);
    const value = value_.toUpperCase();
    const regex = /^([A-Za-z0-9]{4}-){7}[A-Za-z0-9]{4}$/;
    if (regex.test(value)) {
      const parts = value.split("-");
      let joined_key = {
        seed1: "",
        seed2: "",
        seed3: "",
        seed4: "",
        seed5: "",
        seed6: "",
        seed7: "",
        seed8: "",
      };
      parts.map((e, index) => {
        joined_key[`seed${index + 1}`] = e;
        return null;
      });
      setKey(joined_key);
    } else {
      console.log("String does not have correct format");
      if (value.length <= 4) setKey({ ...recovery_key, [seed]: value });
      if (value.length === 4) inputRefs.current[index + 1].focus();
      if (value.length === 0) inputRefs.current[index - 1].focus();
    }
  };
  useEffect(() => {
    console.log(data);
  }, [data]);
  const handleEnter = (e) => {
    if (e.key === "Enter") {
      validateData();
    }
  };
  return (
    <>
      {denied ? (
        <BeneficiarySorry />
      ) : (
        <div className={styles.background} onKeyDown={handleEnter}>
          <div className={styles.title}>{content.BeneficiaryLoginTitle2}</div>
          <div className={styles.subtitle}>{content.BeneficiaryLoginText1}</div>
          <div className={styles.main}>
            <div className={styles.inputs}>
              <div
                className={`${styles.input_div} ${
                  error?.email ? styles.field_error : ""
                }`}
              >
                <div className={styles.input_title}>
                  {dublicatedcontent.dublicatedText42}{" "}
                  <Info message={dublicatedcontent.dublicatedText42} />
                </div>
                <input
                  value={data.email}
                  onChange={(e) =>
                    changeData(e.target.value.toLowerCase(), "email")
                  }
                  placeholder={dublicatedcontent?.dublicatedText42}
                  className={styles.input_input}
                ></input>
                {error?.email ? (
                  <div className={styles.error_div}>{error.email}</div>
                ) : null}
              </div>
              <div
                className={`${styles.input_div} ${
                  error?.birthday ? styles.calendar_error : ""
                }`}
              >
                <div className={styles.input_title}>
                  {content.BeneficiaryLoginBirthdayInput}{" "}
                  <Info message={content.BeneficiaryLoginBirthdayInputInfo} />
                </div>
                {/* <input onChange={(e)=>changeData(e.target.value, "birthday")} className={styles.input_input}></input> */}
                {/* <Calendar value={data.birthday?data.birthday:new Date()} handleDate={handleDate}/> */}
                <CCCalendar
                  handleDate={(e) => setData({ ...data, birthday: e })}
                  parentDate_={data.birthday}
                  yyyy={dublicatedcontent?.yyyy}
                  mm={dublicatedcontent?.mm}
                  dd={dublicatedcontent?.dd}
                />
                {error?.birthday ? (
                  <div className={styles.error_div}>{error.birthday}</div>
                ) : null}
              </div>
              <div
                className={`${styles.big_field} ${
                  error?.key ? styles.field_error : ""
                }`}
              >
                <div className={styles.recovery_input_title}>
                  {content.BeneficiaryLoginRecoverCode}{" "}
                  <Info message={dublicatedcontent.dublicatedText44} />
                </div>
                <div className={styles.recovery_key_div}>
                  {Object.keys(recovery_key).map((seed, index) => {
                    if (index + 1 === Object.keys(recovery_key).length)
                      return (
                        <input
                          ref={(ref) => (inputRefs.current[index] = ref)}
                          onChange={(e) => {
                            changeKey(`${seed}`, e.target.value, index);
                          }}
                          value={recovery_key[seed]}
                          className={styles.recovery_key}
                        ></input>
                      );
                    else
                      return (
                        <>
                          <input
                            ref={(ref) => (inputRefs.current[index] = ref)}
                            onChange={(e) => {
                              changeKey(`${seed}`, e.target.value, index);
                            }}
                            value={recovery_key[seed]}
                            className={styles.recovery_key}
                          ></input>
                        </>
                      );
                  })}
                </div>
                {error?.key ? (
                  <div className={styles.error_div}>{error.key}</div>
                ) : null}
              </div>
            </div>
            <div className={styles.footer}>
              <div className={styles.buttons_div}>
                <button
                  disabled={loginDisabled}
                  onClick={() => validateData()}
                  className={styles.bluebutton}
                >
                  {processing ? processing : dublicatedcontent.dublicatedText45}
                </button>
              </div>
              {error?.error ? (
                <div className={styles.error_div}>{error.error}</div>
              ) : null}
              <div className={styles.rect}></div>
              <div className={styles.subtext}>
                {dublicatedcontent.dublicatedText210}
              </div>
              <div className={styles.buttons_div}>
                <div
                  onClick={() => navigate("/login")}
                  className={styles.darkbutton}
                >
                  {dublicatedcontent.dublicatedText46}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export { BeneficiaryLogin };
